import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
    ViewChild,
} from '@angular/core';
import {
    IModalResult,
    UiModalComponent,
} from '@components/ui-modal/ui-modal.component';
import {
    BulkOperationResponse,
    IQueueItemIdentifier,
    ModalResultType,
} from '@models';
import { QueueItemService } from '@services';
import {
    ISuggestValue,
    UiSuggestComponent,
} from '@uipath/angular/components/ui-suggest';

import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
    templateUrl: './transaction-reviewer.modal.html',
    providers: [QueueItemService],
    styleUrls: ['./transaction-reviewer.modal.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionReviewerModalComponent
    extends UiModalComponent<IQueueItemIdentifier[], IModalResult<BulkOperationResponse>>
    implements OnInit {

    @ViewChild('suggestComponent', { static: true })
    public suggestComponent!: UiSuggestComponent;

    public loading$ = new BehaviorSubject(false);
    public reviewer: ISuggestValue | null = null;

    private _queueItemService = this._injector.get<QueueItemService>(QueueItemService);

    ngOnInit() {

        const reviewer = this.context.data
            .map(item => item.reviewer)
            .reduce((previous, current) =>
                !!previous && !!current &&
                    previous.id === current.id ?
                    previous :
                    undefined,
            );

        const isSameReviewer = !!reviewer;

        if (
            !!this.context.data.length &&
            isSameReviewer &&
            reviewer != null
        ) {
            this.reviewer = {
                id: reviewer.id,
                text: reviewer.userName,
            };
        }
    }

    public onSubmit() {
        if (this.loading$.value) {
            return;
        }

        const userId = this.suggestComponent.value[0] ?
            this.suggestComponent.value[0].id as number :
            null;

        this.loading$.next(true);

        this._queueItemService
            .changeItemReviewer(this.context.data, userId)
            .pipe(
                finalize(
                    () => this.loading$.next(false),
                ),
            ).subscribe(
                (response: BulkOperationResponse) => {
                    this._dialogRef.close({
                        type: ModalResultType.Generic,
                        data: response,
                    });
                },
            );
    }

    public suggestReviewers = (searchTerm?: string, fetchSize = 10, skip: number = 0) =>
        this._queueItemService.suggestReviewers(searchTerm, fetchSize, skip)
}
